/**
 * TRY tutarları için 2 ondalık yuvarlama (self-service ödeme / POS SaleItems ile uyumlu).
 * Backend tarafındaki parasal karşılaştırmalarla aynı sıklıkta tutmak için tek kaynak.
 */
export function roundTry2(value) {
  const n = Number(value);
  if (Number.isNaN(n)) return 0;
  return Math.round(n * 100) / 100;
}
